export const FitToScreenIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7.5 3.5H9.5C10.0523 3.5 10.5 3.94772 10.5 4.5V6.5" stroke="#1e1e1e" strokeLinecap="round" />
      <path d="M6.5 10.5L4.5 10.5C3.94772 10.5 3.5 10.0523 3.5 9.5L3.5 7.5" stroke="#1e1e1e" strokeLinecap="round" />
      <rect x="0.5" y="0.5" width="13" height="13" rx="2.5" stroke="#1e1e1e" />
    </svg>
  );
};
